<template>
    <div class="my-5 p-3">
        <div class="col-12 mb-5">
            <h2 v-html="header" class="text-white pb-4"></h2>
        </div>

        <div class="row">
            <div class="col-md-6 col-xl-4 mb-5" v-for="certificate in certificates">
                <div class="card border-0 bg-transparent">
                    <div>
                        <img v-bind:src="certificate.smallImage" class="card-img-top text-center" :alt="certificate.name">
                    </div>

                    <div class="card-body">
                        <h5 class="card-title text-white text-center">
                            <span v-html="certificate.name">
                            </span>
                        </h5>

                        <div class="event-tags text-center">
                            <form @submit.prevent="generateCertificate(certificate.id)" method="get">
                                <button type="submit" class="btn btn-primary shadow-sm"><i
                                class="fas fa-sm text-white-50"></i>Pobierz certyfikat</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <h3 class="text-center text-white font-italic" v-if="certificates.length == 0"> <u> Aktualnie nie uzyskałeś jeszcze żadnego certyfikatu. </u> </h3>


        <paginator :page="page" :perPage="perPage" :pagination="pagination" :method="setPage"></paginator>

    </div>
</template>

<script>
    import Paginator from './paginator.vue';

    export default {
        props: ['header'],

        components: {
            Paginator
        },

        data() {
            return {
                certificates: [],
                page: 1,
                pagination: [],
                perPage: 9,
            }
        },

        created() {
            this.fetchData();
        },

        methods: {
            fetchData(){
                axios.get('api/user-data/certificates', {
                    params: {
                        page: this.page,
                    }
                })
                .then(response => {
                    this.pagination = response.data.meta;
                    this.perPage = response.data.meta.per_page;
                    this.certificates = response.data.data;
                });
            },

            generateCertificate(certificateId){
                axios({
                    url: '/user-data/'+certificateId+'/getCertificate',
                    method: 'GET',
                    responseType: 'blob',
                })
                .then((response) => {
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'certyfikat.png');
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.$notify({
                        'group': 'foo',
                        'type': 'success',
                        'title': 'Certyfikat został pobrany pomyślnie'
                    });
                });
            },

            setPage(page){
                this.page = page;
                this.fetchData();
            }
        }

    }
</script>
